import { Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import { IContentApiService, IContentApiServiceToken } from "./content-api-service.interface";
import { ContentClient, ContentGetQuery, ContentGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export class ContentApiService implements IContentApiService {

  constructor(
    private contentClient: ContentClient,
  ) { }

  public swagContentGet(query: ContentGetQuery): Observable<ContentGetQueryResult> {
    return this.contentClient.contentGet(query);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ContentApiServiceProvider: Provider[] = [
  { provide: ContentClient },
  { provide: IContentApiServiceToken, useExisting: ContentApiService }
];
